import type { FaireProductEntity } from "../../entity_types/product";

export const p_22vh87r2jw: FaireProductEntity = {
  token: "p_22vh87r2jw",
  type: "product",
  name: "Noah's Ark Convertible Romper",
  brandToken: "b_jgv6czey3x",
  brandName: "Tiny Revival Clothing Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/fa5781041cf68c5754742dce159d23a54cf404bedc6d1cc8b5807659374db576.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0643a10ff9f3af696c11e62f6b91236bda958510917dc77811799403abfe2551.jpeg",
    "https://cdn.faire.com/fastly/c47c932a27f36110ec94bf97b4fa245544c86fc9d06a7aed8ea7334da2c70726.jpeg",
    "https://cdn.faire.com/fastly/72e937a2b9a9b3b2aa66566385c00d583f8e0a2897eb3d3497d703349ea481d3.jpeg",
    "https://cdn.faire.com/fastly/bf13356060ae1137f01f261fbe2539a7fff8a8a88d40c142ebfa2b3c4d411d0c.jpeg",
    "https://cdn.faire.com/fastly/5a67c36801a3d5c67e522b3dd13369eedb4848795907db46f042feaf3464fbba.jpeg",
    "https://cdn.faire.com/fastly/6e327009c30db2ac1fb2fe30a248d2956f14689253b3f5e2fb983114c08478f6.jpeg",
    "https://cdn.faire.com/fastly/0d4642ad732981d5cc05af9ada12125a74c77391dea42948d4cc0d22817b7a8d.jpeg",
    "https://cdn.faire.com/fastly/b0a1b851ad994964e67bfa20a0fcbde73d86c8cb4a8151b1c58e3f7269140f4d.jpeg",
    "https://cdn.faire.com/fastly/b3c79342a6759f707d711f9c0bac9f9468e85ce52c65d46f99b589c9ae8ff2b5.jpeg",
    "https://cdn.faire.com/fastly/298c8eab80ae4456214e8065630e661590262fcd91c37768b8d7e156a34441eb.jpeg",
  ],
  priceDollars: 18,
  description:
    "Bring the timeless tale of Noah's Ark to life with this beautifully designed baby essential. Featuring exquisite hand-watercolored illustrations of Noah's Ark, this romper wraps your little one in love, comfort, and an eye-catching design.\n\n * Heavenly Soft & Breathable: Crafted from 220 gsm 95% Organic Bamboo Lyocell / 5% Spandex for a luxuriously soft, breathable feel that’s perfect for sensitive skin and year-round wear. \n * Easy Diaper Changes: Includes foldover hands and feet with a double zipper design for hassle-free changes. \n * New Foot Grips: Enhanced with slip-resistant foot grips to support your baby as they begin to explore and walk. \n * Ethical Craftsmanship: Fair trade and ethically crafted by our artisans \n * Social Impact: A portion of every purchase is donated to A21 to fight human trafficking. ",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:17.592Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
